module.exports = __webpack_public_path__ + "img/screen_1_quick.8cb3a6d0.png";